var map = {
	"./views/Dashboard.vue": [
		6364,
		364
	],
	"./views/Login.vue": [
		7879
	],
	"./views/Main.vue": [
		9688
	],
	"./views/activity/banner.vue": [
		4187,
		187
	],
	"./views/activity/index.vue": [
		7448,
		448
	],
	"./views/activity/registrationList.vue": [
		4228,
		228
	],
	"./views/activity/type.vue": [
		6167,
		167
	],
	"./views/connection/index.vue": [
		8294,
		294
	],
	"./views/consumer/apply.vue": [
		2021,
		21
	],
	"./views/consumer/components/Point.vue": [
		7804,
		423
	],
	"./views/consumer/components/Team.vue": [
		6601,
		601
	],
	"./views/consumer/details.vue": [
		9258,
		258
	],
	"./views/consumer/marginLog.vue": [
		7985,
		985
	],
	"./views/consumer/students.vue": [
		6473,
		473
	],
	"./views/consumer/teachers.vue": [
		8159,
		159
	],
	"./views/dept/list.vue": [
		3519,
		519
	],
	"./views/information/library.vue": [
		8451,
		451
	],
	"./views/information/orgBank.vue": [
		8084,
		84
	],
	"./views/integral/classification.vue": [
		6913,
		913
	],
	"./views/integral/commodity.vue": [
		6561,
		561
	],
	"./views/integral/log.vue": [
		9204,
		204
	],
	"./views/integral/manageCommodity.vue": [
		6324,
		324
	],
	"./views/integral/orders.vue": [
		5080,
		80
	],
	"./views/integral/reimburse.vue": [
		4943,
		943
	],
	"./views/logs/list.vue": [
		5804,
		804
	],
	"./views/menu/list.vue": [
		7420,
		420
	],
	"./views/menu/list/tenant.vue": [
		1679,
		679
	],
	"./views/model/list.vue": [
		2853,
		853
	],
	"./views/notices/index.vue": [
		4968,
		968
	],
	"./views/order/afterSale.vue": [
		5639,
		639
	],
	"./views/order/task.vue": [
		8264,
		475
	],
	"./views/resource/list.vue": [
		9823,
		823
	],
	"./views/role/list.vue": [
		1602,
		395,
		602
	],
	"./views/settings/components/agreement.vue": [
		9570,
		570
	],
	"./views/settings/gradeSubjects.vue": [
		4277,
		277
	],
	"./views/settings/help.vue": [
		222,
		841
	],
	"./views/settings/sysConfig.vue": [
		3557,
		557
	],
	"./views/tenant/list.vue": [
		7198,
		395,
		198
	],
	"./views/user/list.vue": [
		3132,
		132
	],
	"./views/vip/list.vue": [
		776,
		776
	],
	"./views/vip/orders.vue": [
		2237,
		237
	],
	"./views/withdrawal/income.vue": [
		9015,
		15
	],
	"./views/withdrawal/margin.vue": [
		8535,
		535
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5684;
module.exports = webpackAsyncContext;